import type { User } from 'firebase/auth'

export async function sendUserAuthToMagic(user: User) {
  const isSSR = import.meta.env.SSR

  if (isSSR)
    return

  window.postMessage(JSON.stringify({
    id: 'sp-token',
    token: await user.getIdToken(),
    firebase_uid: user.uid,
  }))

  // HACK: await post message to finish before closing window
  setTimeout(() => {
    window.close()
  }, 0)
}
